'use client'

import { AnimatePresence } from 'motion/react'
import * as React from 'react'

import MenuBgCloseButton from '@/components/MenuBgCloseButton'
import TheMenu from '@/components/TheMenu'
import TheMenuBar from '@/components/TheMenuBar'
import { cn } from '@/lib/utils'
import { useGlobalStateActions, useIsMenuOpen } from '@/state/useGlobalState'

type TheMenuContainerProps = {
  title: string
  className?: string
}

export default function TheMenuContainer({
  title,
  className,
}: TheMenuContainerProps) {
  const { toggleMenuOpen } = useGlobalStateActions()
  const isMenuOpen = useIsMenuOpen()
  return (
    <>
      <div
        id='TheMenuContainer'
        className={cn(
          'the--menu-container-transition',
          'fixed bottom-0 left-0 z-10 flex w-full flex-col-reverse',
          'vM:flex-row vM:top-0 vM:w-auto vM:h-full',
          isMenuOpen
            ? 'vM:translate-x-0 vM:translate-y-0 translate-y-0'
            : 'vM:translate-x-[calc(-1*var(--menu-width))] vM:translate-y-0 translate-y-[calc(var(--menu-height))]',
          className,
        )}
      >
        <TheMenu />
        <TheMenuBar title={title} className='vM:pt-4' />
      </div>
      <AnimatePresence>
        {isMenuOpen && (
          <MenuBgCloseButton
            className='z-8'
            closeMenu={() => {
              toggleMenuOpen()
            }}
          />
        )}
      </AnimatePresence>
    </>
  )
}
